import { matchPath } from 'react-router-dom';
import { paths, routeKeys } from 'url-registry';

import { routeMounts } from './routeMounts';

/** Paths that belong to InterviewApp and must never appear in the recruiter registry. */
const FOREIGN_HIDE_NAV_PREFIXES = [
  '/web-interview',
  '/web-call',
  '/feedback',
  '/reschedule',
] as const;

/**
 * Exact pathnames that used `display: contents` via `includes()` on the old
 * hide-nav list. Prefix matches hide the nav (`startsWith`) but do not switch
 * the shell to contents — only this exact set does.
 */
const CONTENTS_DISPLAY_PATHS: readonly string[] = [
  paths.LOGIN,
  paths.AUTHENTICATE,
  paths.SUPPORT_MICROSOFT_CALLBACK,
  ...FOREIGN_HIDE_NAV_PREFIXES,
  paths.RESTRICTED_ACCESS,
  '/email-decision',
  paths.OAUTH_CONSENT,
];

const HIDE_NAV_TEMPLATES: readonly string[] = routeKeys
  .filter((key) => routeMounts[key].hideNav)
  .map((key) => paths[key]);

export function shouldHideSideNavBar(
  pathname: string,
  isAuthenticated: boolean
): boolean {
  if (!isAuthenticated) {
    return true;
  }
  if (FOREIGN_HIDE_NAV_PREFIXES.some((prefix) => pathname.startsWith(prefix))) {
    return true;
  }
  return HIDE_NAV_TEMPLATES.some(
    (template) => matchPath({ path: template, end: true }, pathname) != null
  );
}

export function shouldUseContentsDisplay(pathname: string): boolean {
  return CONTENTS_DISPLAY_PATHS.includes(pathname);
}
